<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 渠道管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="终端状态" prop="state" label-width="100px">
                <el-select type="text" filterable v-model="searchform.state" style="width:100%">
                  <el-option
                    v-for="(item,index) in statelist"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="注册时间" prop="datelist">
                <el-date-picker
                  style="width:100%"
                  v-model="searchform.datelist"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="经销商" prop="dealerUuid" label-width="100px">
                <el-select
                  type="text"
                  filterable
                  v-model="searchform.dealerUuid"
                  style="width:100%"
                  @change="getpearentkidlist(searchform.dealerUuid)"
                >
                  <el-option
                    v-for="(item,index) in parentlist"
                    :key="index"
                    :label="item.name"
                    :value="item.userUuid"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="分销商" prop="parentUuid" label-width="100px">
                <el-select
                  type="text"
                  filterable
                  v-model="searchform.parentUuid"
                  style="width:100%"
                >
                  <el-option
                    v-for="(item,index) in parentkidlist"
                    :key="index"
                    :label="item.name"
                    :value="item.userUuid"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="search"
                v-permission="['supervise_select']"
              >搜索</el-button>
              <!-- <el-button type="primary" @click="add.addshow=!add.addshow">注册</el-button> -->
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>{{title}}</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
            <el-table-column prop="openid" label="OpenID" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="name" label="终端名称" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="phone" label="终端手机" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="parentUserName" label="所属分销商" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="salesRoom" label="门店" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="注册时间" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="provinceName" label="省" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cityName" label="市" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="areaName" label="区" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="address" label="注册地点" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="state" label="状态" min-width="140" show-overflow-tooltip>
              <template slot-scope="props">
                <el-switch
                  v-model="props.row.state"
                  active-color="#00A854"
                  :active-value="1"
                  inactive-color="#F04134"
                  :inactive-value="0"
                  @change="changeSwitch(props.row,$event)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="160" show-overflow-tooltip fixed="right">
              <template slot-scope="props">
                <el-button
                  type="primary"
                  @click="rowupdate(props.row)"
                  icon="el-icon-edit"
                  v-permission="['promotionrule_update']"
                ></el-button>
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  @click="deletedate(props.row.userUuid)"
                  v-permission="['prizemanage_delete']"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
          <!-- 二维码弹窗 -->
          <el-dialog title="二维码图片" :visible.sync="codeVisible" width="450px" center>
            <div id="qrcode"></div>
          </el-dialog>
          <!--注册 -->
          <!-- <Input-Form :add="add" :search="search" /> -->
          <Update-Form ref="mychild" :update="update" :search="search" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
import {
  vipsearch,
  updatestate,
  makeqrcode,
  deletelist,
  getchildrenonly
} from "@/api/market/channel";
import InputForm from "./components/InputForm";
import UpdateForm from "./components/UpdateForm";
export default {
  components: { InputForm, UpdateForm },
  mounted() {
    //请求部门列表数据并且便利到表格
    this.search();
    getchildrenonly({ userType: 9 }).then(response => {
      this.parentlist = response.data;
    });
  },
  data() {
    return {
      //基础数据
      title: "终端管理",
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      parentlist: [],
      parentkidlist: [],
      statelist: [
        {
          value: -1,
          label: "所有"
        },
        {
          value: 0,
          label: "禁用"
        },
        {
          value: 1,
          label: "启用"
        }
      ],
      codeVisible: false,
      add: {
        addshow: false
      },
      update: {
        form: {
          companyName: null,
          name: null,
          phone: null,
          provinceId: null,
          cityId: null,
          areaId: null,
          address: ""
        },
        row: {},
        show: false
      },
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      searchform: {
        dealerUuid: null,
        parentUuid: null,
        beginTime: null,
        endTime: null,
        datelist: [],
        state: -1,
        userType: 3,
        currPage: 1,
        pageSize: 10
      },
      value: true
    };
  },
  methods: {
    // 获取分销商下拉
    getpearentkidlist(pearent) {
      this.parentkidlist= []
      getchildrenonly({ parentUuid: pearent }).then(response => {
        this.parentkidlist = response.data;
      });
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      vipsearch(obj).then(response => {
        this.tableData = response.data.rows;
        this.packdate(this.tableData);
        this.total_count = response.data.total;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    // 拼数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
      }
    },
    // 修改当行信息
    rowupdate(row) {
      console.log(row);
      let obj = row;
      this.$refs.mychild.propgetcity(obj.provinceId);
      this.$refs.mychild.propgetdistrict(obj.cityId);
      this.update.form = obj;
      this.update.row = obj;
      this.update.show = true;
    },
    // 状态更新
    changeSwitch(row, state) {
      console.log(row);
      updatestate({
        uuid: row.userUuid,
        state: row.state
      }).then(response => {
        this.search();
      });
    },
    // 生成二维码
    // 转化码为二维码
    qrCode(obj) {
      setTimeout(() => {
        this.$nextTick(function() {
          document.getElementById("qrcode").innerHTML = "";
          let qrcode = new QRCode("qrcode", {
            width: 400,
            height: 400,
            text: obj, // 二维码内容 也可以放url
            colorDark: "#000",
            colorLight: "#fff"
          });
        });
      }, 50);
    },
    mankeqrcode(row) {
      console.log(row);
      this.qrCode(row.userUuid);
      this.codeVisible = true;
    },
    //搜索事件
    search() {
      this.currentPage = 1;
      this.Tabledata({
        state: this.searchform.state,
        userType: this.searchform.userType,
        beginTime:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        endTime:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        page: 1,
        rows: this.searchform.pageSize
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.currPage = currPage;
      this.Tabledata({
        userType: this.searchform.userType,
        beginTime:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        endTime:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        rows: this.searchform.pageSize,
        page: this.searchform.currPage
      });
      console.log(currPage);
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize;
      this.search();
    },
    //删除按钮事件
    deletedate(obj) {
      this.$confirm("此操作将永久删除该用户信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deletelist({
            uuids: [obj]
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.search();
            } else {
              this.$message({
                type: "woring",
                message: "删除失败!请检查字段"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
</style>